module.exports = __webpack_public_path__ + "static/img/word.204fec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word.png
// module id = NRYx
// module chunks = 171